import { buildProps } from '@sgui-plus/utils/props'
import { isBool } from '@sgui-plus/utils/util'

import type { ExtractPropTypes } from 'vue'

export const tagProps = buildProps({
  closable: Boolean,
  type: {
    type: String,
    values: ['primary', 'success', 'info', 'warning', 'danger', ''],
    default: '',
  },
  transition: {
    type: Boolean,
    default: true
  },
  color: {
    type: String,
    default: '',
  },
  size: {
    type: String,
    values: ['large', 'default', 'small'],
  },
  fill: {
    type: Boolean,
    default: false
  },
  outline: {
    type: Boolean,
    default: false
  },
  checkable: {
    type: Boolean,
    default: false
  },
  checked: {
    type: Boolean,
    default: false
  },
  backgroundColor: {
    type: String,
    default: '',
  }
} as const)
export type TagProps = ExtractPropTypes<typeof tagProps>

export const tagEmits = {
  onClose: (evt: MouseEvent) => evt instanceof MouseEvent,
  onClick: (evt: MouseEvent) => evt instanceof MouseEvent,
  onChange: (status: Boolean) => isBool(status)
}
export type TagEmits = typeof tagEmits
